module.exports = {
      id: "alert-icon-usage",
      viewBox: "0 0 126 126",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#alert-icon",
      toString: function () {
        return this.url;
      }
    }